<template>
  <router-view/>
  <AppLoader/>
  <AppAlert/>
  <AppConfirm/>
</template>

<script>
import AppLoader from '@/components/AppLoader.vue'
import AppAlert from '@/components/AppAlert.vue'
import AppConfirm from '@/components/AppConfirm.vue'
export default {
  components: {
    AppLoader,
    AppAlert,
    AppConfirm
  }
}
</script>
<style>
p { margin-bottom: 4px; }
</style>
